import { getFormattedNameFromObject } from "../../services/stringService";
import { Icon } from "@coverme/icons";
import React from "react";
import { calculateTotalAllowableIncome, getMagiMonthlyIncomeForMember } from "../../services/magiServices";

export function MiniFacesheetIncome1({ incomeOpen, onClick, magiHousehold, countableMembers }) {
    const totalIncome = calculateTotalAllowableIncome(magiHousehold);
    return (
        <>
            <div className={`mini-facesheet__section-title ${incomeOpen && "open"}`} onClick={onClick}>
                <h4>MAGI Income (${totalIncome.toFixed(2)})</h4>
                <span className="mini-facesheet__arrow">
                    <Icon icon={"arrow"} color={"blue"} height={"8"} />
                </span>
            </div>
            <div className="mini-facesheet__income-content">
                <div className="mini-facesheet__padding">
                    <h3 className="sub-heading">Countable</h3>
                    {countableMembers.map((member, i) => {
                        const income = getMagiMonthlyIncomeForMember(member.personId, magiHousehold);
                        return (
                            <p className="mini-facesheet__household-name" key={i}>
                                {getFormattedNameFromObject(member)}: <span className="h4">${income.toFixed(2)}</span>
                            </p>
                        );
                    })}
                </div>
            </div>
        </>
    );
}

export function MiniFacesheetIncome({ incomeOpen, onClick, magiHousehold, countableMembers }) {
    const totalIncome = calculateTotalAllowableIncome(magiHousehold);
    return (
        <>
            <h3 className="sub-heading">Countable</h3>
            {countableMembers.map((member, i) => {
                const income = getMagiMonthlyIncomeForMember(member.personId, magiHousehold);
                return (
                    <p className="mini-facesheet__household-name" key={i}>
                        {getFormattedNameFromObject(member)}: <span className="h4">${income.toFixed(2)}</span>
                    </p>
                );
            })}
        </>
    );
}
